import * as queryString from 'query-string';

export const getDefaultAvatar = (source = {}) => {
    if (source?.isCollege) {
        return '/img/v2/icons/icon-avatar-college.svg';
    }
    if (source?.isHighSchool) {
        return '/img/v2/icons/icon-avatar-school.svg';
    }
    return '/img/v2/icons/icon-avatar-club.svg';
};

export const getNameInitials = (source) => {
    const { firstName, lastName } = source;
    if (firstName && lastName) {
        return `${firstName?.charAt(0)?.toUpperCase()}${lastName
            ?.charAt(0)
            ?.toUpperCase()}`;
    }
    return '';
};

export const parseQueryParams = (search = {}) => {
    let queryParamsObj = {};
    const queryParams = queryString.parse(search);
    if (queryParams.sort) {
        queryParamsObj = { ...queryParamsObj, sort: queryParams.sort };
    }
    if (queryParams.order) {
        queryParamsObj = { ...queryParamsObj, order: queryParams.order };
    }
    if (queryParams.gender) {
        queryParamsObj = { ...queryParamsObj, gender: queryParams.gender };
    }
    if (queryParams.division) {
        queryParamsObj = { ...queryParamsObj, division: queryParams.division };
    }
    if (queryParams.conference) {
        queryParamsObj = { ...queryParamsObj, conference: queryParams.conference };
    }
    if (queryParams.utrMax) {
        queryParamsObj = { ...queryParamsObj, utrMax: Number(queryParams.utrMax) };
    }
    if (queryParams.utrMin) {
        queryParamsObj = { ...queryParamsObj, utrMin: Number(queryParams.utrMin) };
    }
    if (queryParams.utrTeamType) {
        queryParamsObj = {
            ...queryParamsObj,
            utrTeamType: queryParams.utrTeamType,
        };
    }
    if (queryParams.utrType) {
        queryParamsObj = { ...queryParamsObj, utrType: queryParams.utrType };
    }
    if (queryParams.utrFitRating) {
        queryParamsObj = { ...queryParamsObj, utrFitRating: queryParams.utrFitRating };
    }
    if (queryParams.utrFitPosition) {
        queryParamsObj = { ...queryParamsObj, utrFitPosition: queryParams.utrFitPosition };
    }
    if (queryParams.nationality) {
        queryParamsObj = {
            ...queryParamsObj,
            nationality: queryParams.nationality,
        };
    }
    if (queryParams.recruitingStatus) {
        queryParamsObj = {
            ...queryParamsObj,
            recruitingStatus: queryParams.recruitingStatus,
        };
    }
    if (queryParams.location) {
        queryParamsObj = { ...queryParamsObj, location: queryParams.location };
    }
    if (queryParams.lng) {
        queryParamsObj = { ...queryParamsObj, lng: queryParams.lng };
    }
    if (queryParams.lat) {
        queryParamsObj = { ...queryParamsObj, lat: queryParams.lat };
    }
    if (queryParams.locationInputValue) {
        queryParamsObj = {
            ...queryParamsObj,
            locationInputValue: queryParams.locationInputValue,
        };
    }
    if (queryParams.locationStateName) {
        queryParamsObj = {
            ...queryParamsObj,
            locationStateName: queryParams.locationStateName,
        };
    }
    if (queryParams.locationCountryName) {
        queryParamsObj = {
            ...queryParamsObj,
            locationCountryName: queryParams.locationCountryName,
        };
    }
    if (queryParams.distance) {
        queryParamsObj = { ...queryParamsObj, distance: queryParams.distance };
    }
    if (queryParams.hsGradYears) {
        const gradYears = {};
        if (Array.isArray(queryParams.hsGradYears)) {
            queryParams.hsGradYears.forEach(v => {
                gradYears[v] = true;
            });
        } else {
            gradYears[queryParams.hsGradYears] = true;
        }
        queryParamsObj = {
            ...queryParamsObj,
            hsGradYears: gradYears,
        };
    }
    if (queryParams.utrReliability) {
        const utrReliability = {};
        if (Array.isArray(queryParams.utrReliability)) {
            queryParams.utrReliability.forEach(v => {
                utrReliability[v] = true;
            });
        } else {
            utrReliability[queryParams.utrReliability] = true;
        }
        queryParamsObj = {
            ...queryParamsObj,
            utrReliability,
        };
    }

    return queryParamsObj;
};

export const setQueryParams = (filters) => {
    let gradYears = [];
    let utrReliability = '';
    if (filters.hsGradYears) {
        gradYears = Object.entries(filters.hsGradYears).filter(v => v[1]).map((v) => v[0]);
    }
    if (filters.utrReliability) {
        utrReliability = Object.entries(filters.utrReliability).filter(v => v[1]).map((v) => v[0]);
    }
    return queryString.stringify(
        { ...filters, hsGradYears: gradYears, utrReliability },
        { encode: false, arrayFormat: '' },
    );
};
